import { styled } from "@mui/material/styles";

const PageContainer = styled("div")(`
  height: 100vh;
  width: 100%;
`);

export default PageContainer;
